<template>
  <div>
    <input type="text" v-model="user_location" required name="loc_address" id="loc_address" class="form-control"
      @input="initLocationAutocomplete" placeholder="Location">
    <div id="location-suggestions"></div>
  </div>
</template>
    
<script>
import axios from 'axios';

export default {
  props: {
    google_api_key: { default: '' },
    ticket: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      user_location: null
    }
  },
  mounted() {
    var vm = this;
    //integating google map api for places suggestion
    if (this.google_api_key) {
      let script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${vm.google_api_key}&libraries=places`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      console.log(script.src);
      //if i am in update page then show the already placed name in input field
    }
    if (vm.ticket) {
      vm.user_location = vm.ticket.location_name;
      this.$emit('location_object', this.user_location);
    }


  },
  methods: {
    initLocationAutocomplete() {
      if (this.google_api_key) {
        // Initialize the Google Maps Places service
        const autocompleteService = new google.maps.places.AutocompleteService();
        const request = {
          input: 'test', // A test input for validation
        };

        // Try to get place predictions using the API key
        autocompleteService.getPlacePredictions(request, (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            var obj = '';
            var input = document.getElementById('loc_address');
            var autocomplete = new google.maps.places.Autocomplete(input);
            var test = autocomplete.setTypes(['geocode']);
            autocomplete.addListener('place_changed', () => {
              var place = autocomplete.getPlace();
              if (place.geometry) {
                var obj = place.geometry.location;
                this.$emit('location_object', obj);
              }
            });
          }
        });
      }
      this.$emit('location_object', this.user_location);

    },
  }

}
</script>
<style>
.pac-container:after {
  /* Disclaimer: not needed to show 'powered by Google' if also a Google Map is shown */

  background-image: none !important;
  height: 0px;
}
</style>
    







